import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { Fade, Grow } from "@mui/material";
import Box from "@mui/material/Box";
const EffectContent = ({ type, timer, children, }) => {
    const [mostrarBox, setMostrarBox] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const timerObj = setTimeout(() => {
            setMostrarBox(true);
        }, timer); // 3000ms = 3 segundos
        return () => clearTimeout(timerObj);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (type === "fade") {
        return (_jsx(Fade, Object.assign({ in: mostrarBox }, { children: _jsx(Box, Object.assign({ ref: ref }, { children: children })) })));
    }
    if (type === "grow") {
        return (_jsx(Grow, Object.assign({ in: mostrarBox }, { children: _jsx(Box, Object.assign({ ref: ref }, { children: children })) })));
    }
    return _jsx(_Fragment, { children: "children" });
};
export default EffectContent;
